import {
  ISubclientData,
  ISubclientDetailData,
  ISubclientParams,
  ISubclientSyncResponse,
  IUpdateSubclient,
  SubclientSyncResponse,
} from "@/entities";
import {
  BACKEND_BASE_URL,
  IGenericResponse,
  IPageResponse,
  IResponseError,
  ISubclientsReportRequest,
} from "@/services";
import { ISubclientService } from "@/services/backend/subclient/subclient.types";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";

export class SubclientService implements ISubclientService {
  async getSubclients(
    params: ISubclientParams
  ): Promise<IPageResponse<ISubclientData> | undefined> {
    const { response, error } = await handleResponse<IPageResponse<ISubclientData>, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/sub-client`, { params })
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getSubclientDetail(idSubclient: number): Promise<ISubclientDetailData | undefined> {
    const { response, error } = await handleResponse<ISubclientDetailData, IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/sub-client/${idSubclient}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async saveUpdateSubclient(
    updateClient: IUpdateSubclient
  ): Promise<IGenericResponse<ISubclientDetailData> | undefined> {
    const { response, error } = await handleResponse<
      IGenericResponse<ISubclientDetailData>,
      IResponseError
    >(Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/sub-client/`, updateClient));

    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async updateStatusSubclient(idSubclient: number): Promise<number | undefined> {
    const { response, error } = await handleResponse<number, IResponseError>(
      Vue.$axios.patch(`${BACKEND_BASE_URL}/api/configuration/v1/sub-client/${idSubclient}`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async postGenerateSubclientsReport(request?: ISubclientsReportRequest): Promise<void> {
    await handleResponse<Promise<void>, IResponseError>(
      Vue.$axios.post(`${BACKEND_BASE_URL}/api/configuration/v1/report/sub-client`, request)
    );
  }

  async syncSubclient(id: number): Promise<ISubclientSyncResponse | undefined> {
    const { response, error } = await handleResponse<ISubclientDetailData, IResponseError>(
      Vue.$axiosSilentLoading.post(`${BACKEND_BASE_URL}/api/configuration/v1/sub-client/${id}/sync`)
    );
    if (error) {
      const errorData = error.response;
      if (errorData?.status != 500 && errorData?.data) {
        return new SubclientSyncResponse(false, null, errorData?.data?.message);
      }
      return undefined;
    } else {
      return new SubclientSyncResponse(true, response!.data);
    }
  }
}
